import React from 'react'
import { logger, metrics } from 'lib/slardar-utils'
import { isNewVersion } from 'lib/version'

const error_pic = require('static/error-pic@3x.jpg')

function Error() {
  return (
    <section>
      <div
        className="tw-w-300 tw-absolute"
        style={{
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        <img
          src={error_pic}
          className={`tw-object-center tw-object-fill tw-w-300 tw-h-300 tw-mb-20`}
        />
        <p
          className={`tw-text-18 tw-text-center tw-text-old-black tw-leading-25`}
        >
          oh～oh网络异常
        </p>
        <p
          className={`tw-text-18 tw-text-center tw-text-old-black tw-leading-25`}
        >
          我们正在全力为您找回页面
        </p>
      </div>
    </section>
  )
}
Error.getInitialProps = async ({
  pathname,
  asPath,
  query,
  req,
  res,
  err,
}: any) => {
  const statusCode = res ? res.statusCode : err ? err.statusCode : 404
  const referrer = res ? req?.headers?.referer : document?.referrer
  if (statusCode === 404) {
    metrics.counter('404', {
      from_error_page: true,
    })
  } else if (res && req?.metrics && req?.logger) {
    // server side error.
    req.metrics.emitCounter('error_page', 1, undefined, {
      statusCode,
    })
    req.logger.error(
      `[error page] error_page referrer = ${referrer} status code = ${statusCode} error message = ${err?.message} error stack = ${err?.stack} url = ${asPath}`
    )
  } else if (!res) {
    // client side error.
    metrics.counter('error_page', {
      statusCode,
    })
    logger.error(
      `[error page] error_page referrer = ${referrer} error message = ${err?.message} error stack = ${err?.stack} url = ${asPath}`
    )
  }

  return {
    err,
    statusCode,
    pathname,
    asPath,
    query,
    _pageType: isNewVersion(req?._isNewVersion) ? 'full auto-nav' : '',
  }
}
export default Error
